import { oz } from '@weft/utils';

export const FixedPerUnitPricingConfigurationSchema = oz.object({
  price: oz.number({ invalid_type_error: 'Fixed amount is required' }).nonnegative(),
  units: oz.number({ invalid_type_error: 'Units are required' }).nonnegative(),
  upfrontPay: oz.boolean().default(false),
}).openapi('FixedPerUnitPricingConfiguration');
